import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Order } from 'src/app/common/event.model';
import { CartInfoBoxComponent } from 'src/app/components/cart-info-box/cart-info-box.component';
import { HeroEventComponent } from 'src/app/components/hero-event/hero-event.component';
import { PaymentInfoComponent } from 'src/app/components/payment-info/payment-info.component';
import { PaymentComponent } from 'src/app/components/payment/payment.component';
import { UsersFormFieldsComponent } from 'src/app/components/users-form-fields/users-form-fields.component';
import { Services } from "src/app/services/api.service"
import { EventsService } from 'src/app/services/getEvents';
import { OrderService } from 'src/app/services/getOrder.service';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.sass'],
  providers: [ Services ],
  standalone: true,
  imports: [HeroEventComponent, UsersFormFieldsComponent, CommonModule, CartInfoBoxComponent, PaymentInfoComponent, PaymentComponent]
})

export class UserFormComponent implements OnInit {
  cart:any;
  buyMembership: boolean = false;
  numberOfUsers: number = 0;
  showPayment: boolean = false;
  eventId: number;
  orderId: number;
  actionId: string;
  hashedId: string;
  hasPayment: any;
  event: any;
  eventProfileType: string = "";
  orderInfo: any;
  customerProfile: any;
  token = localStorage.getItem('accessTokenCentral' + environment.connId);
  connId: string = environment.connId;
  loader = document.getElementById("loader-container");
  isEventMembersExlusive!: boolean;

  constructor(
    public Services: Services,
    private eventsService: EventsService,
    private readonly userProfileService: GetUserProfileService,
    private readonly orderService: OrderService,
    private route: ActivatedRoute,
    private readonly destroyRef: DestroyRef
  ) {
    this.loader!.style.display = "flex";
    this.getCustomerProfile();
    this.getOrderData(false);

    this.hashedId = this.route.snapshot.paramMap.get('hashedId') || "";
    this.eventId = +this.route.snapshot.paramMap.get('eventId')!;
    this.orderId = +this.route.snapshot.paramMap.get('orderId')!;
    this.actionId = this.route.snapshot.paramMap.get('actionId')!;

    this.userProfileService.getUserProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (userProfile) => {
        if (!userProfile.gdprCheck) {
          window.location.href = environment.url;
        }
      },
      error: () => {}
    });
  }

  ngOnInit(): void {
    this.getEventDetails(this.actionId);
  }

  getEventDetails(actionId: string) {
    this.eventsService.getEvent(this.eventId, actionId, this.hashedId).subscribe({
      next: (response: any) => {
        const resJson = response.data;
        this.eventProfileType = resJson.event.profileType;
        this.event = resJson;
        this.isEventMembersExlusive = this.event.action.membersExclusive;
      },
      error: (error: { status: number }) => {
        if (error.status === 404 || error.status === 500 || error.status === 400) {
          document.location = `${environment.redirectUrl}`;
        }
      }
    });
  }

  getOrderData(forceReload: boolean) {
    let orderId = this.route.snapshot.paramMap.get('orderId');

    if (!orderId) return;

    this.orderService.getOrder(Number(orderId), forceReload).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: Order) => {
        this.cart = data;
        this.hasPayment = data.transactionInfo.hasPayment;
        this.numberOfUsers = data.items.length;

        let orderInfoString = localStorage.getItem('orderInfo');
        if (orderInfoString !== null) {
          this.orderInfo = JSON.parse(orderInfoString);

          if ((this.orderInfo?.orderId === this.orderId) && (this.orderInfo?.cardType === "aircashpay" || this.orderInfo?.cardType === "kekspay")) {
            this.showPayment = true;
          }
        }

        this.loader!.style.display = "none";
      },
      error: (error: { status: number; }) => {
        if (error.status === 401) {
          this.Services.logout();
        }
      }
    });
  }

  getCustomerProfile() {
    this.userProfileService.getConnectionUserProfile().subscribe({
      next: (data: any) => {
        this.customerProfile = data.data;
      }
    });
  }

  changeShowPayment(show: boolean) {
    this.showPayment = show;
    this.getOrderData(true);
  }
}
